import redirectToUrl from 'syf-js-utilities/helpers/redirectToUrl';
import formatAuthRequest from './formatAuthRequest';
import combineUrlAndParams from './combineUrlAndParams';
/**
 * Form the auth request and redirect to Global Auth Server
 * @example
 * baseURL = auth-qa.syf.com
 * clientId = {GET_THIS_FROM_DEV_PORTAL}
 * redirectURI = `${ORIGIN}/${APP_BASENAME}/callback`
 * loginHintURL = qa.synchronycredit.com/login/lowes/?client=lowes
 * scope = read write or read write sensitive:read sensitive:write
 * navigateTo = '/profile'
 */
export const redirectToAuth = ({ baseURL, clientId, redirectURI, loginHintURL, scope, navigateTo, idToken, prompt }) => {
    const { oauthRedirectUri, requestBodyQueryParams } = formatAuthRequest({
        baseURL,
        clientId,
        redirectURI,
        loginHintURL,
        scope,
        navigateTo,
        idTokenHint: idToken,
        prompt
    });
    redirectToUrl(combineUrlAndParams(oauthRedirectUri, requestBodyQueryParams));
};
export default redirectToAuth;
